import { call } from 'redux-saga/effects';

import * as AuthConstants from '../../auth/constants/auth';
import * as D from '../../deps';
import * as Workers from '../workers';

export default [
  {
    actionType: D.Constants.Listener.ListenerActions.LISTENER_AUTHENTICATED,
    handler: Workers.Authentication.initialize,
    concur: 'takeLatest',
  },
  {
    actionType: D.Constants.Api.ApiActions.GET_FEEDBACK_SUCCESS,
    handler: Workers.UserProfile.getFeedbackSuccess,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.App.AppActions.LISTENER_REAUTH,
    handler: Workers.Authentication.reauthListener,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Api.ApiActions.LOGIN_FAIL,
    handler: Workers.Authentication.loginFail,
    concur: 'takeEvery',
  },
  {
    actionType: AuthConstants.ActionTypes.LOGOUT,
    handler: Workers.Authentication.logout,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Login.LoginActions.RESET_PASSWORD,
    handler: Workers.Authentication.resetPassword,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.ListenerExternals.Actions.REGISTER,
    handler: Workers.Authentication.register,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Login.LoginActions.AUTHENTICATE_LISTENER,
    handler: function* auth(action) {
      yield call(Workers.Authentication.authenticateListener, action.payload);
    },
    concur: 'takeLatest',
  },
  {
    actionType: D.Constants.Login.LoginActions.LOGIN_FLOW_COMPLETE,
    handler: Workers.Authentication.loginToCommunity,
    concur: 'takeEvery',
  },
  {
    actionType: AuthConstants.ActionTypes.LOGOUT_FROM_COMMUNITY,
    handler: Workers.Authentication.logoutFromCommunity,
    concur: 'takeEvery',
  },
];
